const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("../view/Link");
const URLMake = require("../../../shared/URLMake");
const Copy = require("../util/CopyTable").get404Copy();
const AssetsUtil = require("../util/AssetsUtil");
const styles = require("./styles/GotProblems.css");

// Please note that the server may render this component without sending any
// Javascript. If you add any interactivity to this component, make sure it
// can fallback. See noJS in TopBar or BottomBar for an example.

module.exports = createReactClass({
	displayName: "GotProblems",

	propTypes: {
		message: PT.node.isRequired,
		linkOrButton: PT.node,
		isSevere: PT.bool,
	},

	render: function() {
		const messageClass = this.props.isSevere
			? styles.messageSevere
			: styles.message;

		let linkOrButton = this.props.linkOrButton;
		if (!linkOrButton) {
			linkOrButton = (
				<Link to={URLMake.forOffice()} className={styles.link}>
					{Copy.home}
				</Link>
			);
		}

		return (
			<div className={styles.main}>
				<img className={styles.image} src={AssetsUtil.getGotProblems()} />
				<div className={styles.textContainer}>
					<div className={messageClass}>{this.props.message}</div>
					{linkOrButton}
				</div>
			</div>
		);
	},
});
